import React, { useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../services/firebase';
import AdminProducts from './AdminProducts';
import AdminBlogs from './AdminBlogs';
import AdminDashboard from './AdminDashboard';
import AdminContactMessages from './AdminContactMessages';
import './AdminLayout.css';

const AdminLayout = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    setLoading(true);
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <AdminDashboard />;
      case 'products':
        return <AdminProducts />;
      case 'blogs':
        return <AdminBlogs />;
      case 'messages':
        return <AdminContactMessages />;
      default:
        return <AdminDashboard />;
    }
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <div className="admin-sidebar">
        <div className="sidebar-header">
          <h2>DHRTI MAA</h2>
          <p>Admin Panel</p>
        </div>
        
        <nav className="sidebar-nav">
          <button
            className={`nav-item ${activeTab === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActiveTab('dashboard')}
          >
            <span className="nav-icon">📊</span>
            Dashboard
          </button>
          
          <button
            className={`nav-item ${activeTab === 'products' ? 'active' : ''}`}
            onClick={() => setActiveTab('products')}
          >
            <span className="nav-icon">🛍️</span>
            Products
          </button>
          
          <button
            className={`nav-item ${activeTab === 'blogs' ? 'active' : ''}`}
            onClick={() => setActiveTab('blogs')}
          >
            <span className="nav-icon">📝</span>
            Blogs
          </button>
          
          <button
            className={`nav-item ${activeTab === 'messages' ? 'active' : ''}`}
            onClick={() => setActiveTab('messages')}
          >
            <span className="nav-icon">💬</span>
            Messages
          </button>
        </nav>
        
        <div className="sidebar-footer">
          <button 
            className="logout-btn"
            onClick={handleLogout}
            disabled={loading}
          >
            {loading ? 'Logging out...' : 'Logout'}
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="admin-main">
        <div className="admin-header">
          <h1>
            {activeTab === 'dashboard' && 'Dashboard'}
            {activeTab === 'products' && 'Product Management'}
            {activeTab === 'blogs' && 'Blog Management'}
            {activeTab === 'messages' && 'Contact Messages'}
          </h1>
        </div>
        
        <div className="admin-content">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
